import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { ModalContainer } from './modal-container.component';

const sortOptions = [
  { label: 'Urutkan Nama A-Z', sortType: 'asc', sortBy: 'full_name' },
  { label: 'Urutkan Nama Z-A', sortType: 'desc', sortBy: 'full_name' },
  { label: 'Tanggal Lahir Terbaru - Terdahulu', sortType: 'desc', sortBy: 'birth_date' },
  { label: 'Tanggal Lahir Terdahulu - Terbaru', sortType: 'asc', sortBy: 'birth_date' },
  { label: 'Tanggal Reg. Terbaru - Terdahulu', sortType: 'desc', sortBy: 'last_registered_at' },
  { label: 'Tanggal Reg. Terdahulu - Terbaru', sortType: 'asc', sortBy: 'last_registered_at' },
];

export function ModalTableSortComponent({ visible, initialValue, onClose, onChange, options = sortOptions }) {
  const [selected, setSelected] = useState(initialValue || sortOptions[4]);
  useEffect(() => {
    if (initialValue) {
      setSelected(initialValue);
    }
  }, [visible, initialValue]);

  return (
    <ModalContainer visible={visible}>
      <div id='show-item' class={clsx('w-[380px] bg-white rounded-sm p-5 relative', !visible && 'hidden')}>
        <div class='relative text-center py-4'>
          <div class='mb-5 text-center font-bold text-sm'>Sort</div>

          <button type='button' class='absolute top-0 right-0 border-0' onClick={onClose}>
            <span class='icon-ico-close'></span>
          </button>
        </div>

        <div className='max-h-[40vh] scroll mb-5'>
          {options.map((item, index) => (
            <div class='flex items-center p-3'>
              <div class='form-check items-center justify-center' onClick={() => setSelected(item)} key={item.label}>
                <input
                  id={item.label}
                  type='radio'
                  name='sort'
                  class='form-check-input appearance-none rounded-full h-4 w-4 border border-gray-1 bg-white checked:bg-green checked:border-green focus:outline-none transition duration-200 align-top bg-no-repeat bg-center bg-contain float-left cursor-pointer'
                  checked={item.label === selected.label}
                />
              </div>
              <label htmlFor={item.label} class='text-sm text-gray font-medium ml-4 cursor-pointer'>
                {item.label}
              </label>
            </div>
          ))}
        </div>

        <div class='flex justify-between items-center pb-2'>
          <div class='w-[48%]'>
            <button
              type='button'
              onClick={() => {
                onClose();
              }}
              class='block w-full rounded-sm border border-solid border-gray-1 py-2 px-2 text-sm font-semibold text-dark hover:bg-green-status transition duration-75 ease-in-out'
            >
              Cancel
            </button>
          </div>
          <div class='w-[48%]'>
            <button
              onClick={() => {
                onChange({ selected });
              }}
              class='bg-green w-full hover:bg-dark-green transition duration-75 ease-in-out rounded-sm text-white py-2 font-semibold text-sm px-7'
              type='button'
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}
